import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Layout from './navigation/layout';
import AuthProvider from './lib/auth';
import { TenantProvider } from './lib/context/TenantContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './lib/context/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { UserProvider } from './lib/context/UserContext';
import StatsigProviderWrapper from './lib/wrappers/statsig/statsigProviderWrapper';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <StatsigProviderWrapper>
          <QueryClientProvider client={queryClient}>
            <TenantProvider>
              <UserProvider>
                <ThemeProvider theme={theme}>
                  <Router>
                    <Layout />
                  </Router>
                </ThemeProvider>
              </UserProvider>
            </TenantProvider>
          </QueryClientProvider>
        </StatsigProviderWrapper>
      </AuthProvider>
      <ToastContainer
        autoClose={2000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="colored"
      />
    </ErrorBoundary>
  );
}

export default App;
